import React from "react";
import Slider from "react-slick";
import { Col, Container, Image, Row } from "react-bootstrap";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useHistory } from "react-router-dom";
import { isMobile, isMobileOnly } from "react-device-detect";
import { ImageUrl } from "../../../../../../Helpers/request";

const MiShopDiamondsByShap = () => {
  const history = useHistory();

  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const shopbyshape = (value) => {
    var data1 = {
      shape: value,
    };
    sessionStorage.setItem("bw_d_filter", JSON.stringify(data1));
    history.push("/diamonds");
    window.scrollTo(0, 0);
  };

  const shapData = [
    {
      shapName: "Round",
      shapImg: `${ImageUrl}diamond-shape/round-diamond.webp`,
      shapUrl: "Round",
    },
    {
      shapName: "Princess",
      shapImg: `${ImageUrl}diamond-shape/princess-diamond.webp`,
      shapUrl: "Princess",
    },
    {
      shapName: "Cushion",
      shapImg: `${ImageUrl}diamond-shape/cushion-diamond.webp`,
      shapUrl: "cushion",
    },
    {
      shapName: "Emerald",
      shapImg: `${ImageUrl}diamond-shape/emerald-diamond.webp`,
      shapUrl: "emerald",
    },
    {
      shapName: "Oval",
      shapImg: `${ImageUrl}diamond-shape/oval-diamond.webp`,
      shapUrl: "Oval",
    },
    {
      shapName: "Radiant",
      shapImg: `${ImageUrl}diamond-shape/radiant-diamond.webp`,
      shapUrl: "Radiant",
    },
    {
      shapName: "Asscher",
      shapImg: `${ImageUrl}diamond-shape/asscher-diamond.webp`,
      shapUrl: "Asscher",
    },
    {
      shapName: "Marquise",
      shapImg: `${ImageUrl}diamond-shape/marquise-diamond.webp`,
      shapUrl: "Marquise",
    },
    {
      shapName: "heart",
      shapImg: `${ImageUrl}diamond-shape/heart-diamond.webp`,
      shapUrl: "heart",
    },
    {
      shapName: "Pear",
      shapImg: `${ImageUrl}diamond-shape/pear-diamond.webp`,
      shapUrl: "Pear",
    },
  ];
  const shapSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 10,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
    beforeChange: (current, next) => {
      document
        .querySelectorAll('.slick-slide[aria-hidden="true"] a, .slick-slide[aria-hidden="true"] button, .slick-slide[aria-hidden="true"] input')
        .forEach(el => el.setAttribute('tabindex', '-1'));
    },
    afterChange: () => {
      document
        .querySelectorAll('.slick-slide:not([aria-hidden="true"]) a, .slick-slide:not([aria-hidden="true"]) button, .slick-slide:not([aria-hidden="true"]) input')
        .forEach(el => el.removeAttribute('tabindex'));
    }
  };

  return (
    <div className="mi_shop_diamonds_by_shap_section">
      <Container fluid className="p-md-0">
            <div className="mi_main_heading_shop_Daimonds_by_Shap">
              <h2>Shop Diamonds By Shape</h2>
            </div>
            <TabContext value={value} className="mi_tab_outerrr">
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
                className="mi_shap_tabs_list"
              >
                <Tab
                  label="Earth Grown"
                  value="1"
                  className="border-right border-dark my-2 mi_shap_tabs"
                />{" "}
                <vr></vr>
                <Tab label="Lab Grown" value="2" className="mi_shap_tabs" />
              </TabList>
              <TabPanel value="1">
                <div className="mi_shap_mobile_view">
                  <Slider {...shapSettings}>
                    {shapData.map((val) => (
                      <div>
                        <div
                          className="mi_shap_icon_text"
                          onClick={() => shopbyshape(val.shapUrl)}
                        >
                          <Image
                            src={val.shapImg}
                            className="mi_shap_img"
                            alt={val.shapName + "shap Image"}
                          ></Image>
                          <p>{val.shapName}</p>
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>

                {/* <div className='mi_shap_row'>
                           <ul>
                           {shapData.map((val) => 
                            <li>
                              <div className='mi_shap_icon_text' onClick={()=> shopbyshape(val.shapUrl)}>
                                <Image src={val.shapImg} className='mi_shap_img' alt={val.shapName + 'shap Image' }></Image>
                                <p>{val.shapName}</p>
                              </div>
                            </li>
                           )
                           } 
                           </ul>
                      </div> */}
              </TabPanel>
              <TabPanel value="2">
                {isMobile ? (
                  <div className="mi_shap_mobile_view">
                    <Slider {...shapSettings}>
                      {shapData.map((val) => (
                        <div>
                          <div
                            className="mi_shap_icon_text"
                            onClick={() => shopbyshape(val.shapUrl)}
                          >
                            <Image
                              src={val.shapImg}
                              className="mi_shap_img"
                              alt={val.shapName + "shap Image"}
                            ></Image>
                            <p>{val.shapName}</p>
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </div>
                ) : (
                  <div className="mi_shap_row">
                    <ul>
                      {shapData.map((val) => (
                        <li>
                          <div
                            className="mi_shap_icon_text"
                            onClick={() => shopbyshape(val.shapUrl)}
                          >
                            <Image
                              src={val.shapImg}
                              className="mi_shap_img"
                              alt={val.shapName + "shap Image"}
                            ></Image>
                            <p>{val.shapName}</p>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </TabPanel>
            </TabContext>
      </Container>
    </div>
  );
};

export default MiShopDiamondsByShap;
